export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT = 'name asc';

// Websocket Channels
export const JOB_PROCESS_CHANNEL = 'JobProcessChannel';
export const REFERRAL_CHANNEL = 'Review::ReferralChannel';
export const AI_JOB_CHANNEL = 'AIJobChannel';
export const ADMISSION_CHANNEL = 'Review::AdmissionChannel';
export const LOCATION_EPISODE_CHANNEL = 'LocationEpisodeChannel';
